export default "__VITE_ASSET__CJV_c9CG__"